module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('edit-pane', {
    attrs: {
      "prefix": (_vm.formData.type ? _vm.formData.type + ': ' : 'Workflow: '),
      "title": (_vm.formData.name ? _vm.formData.name : 'Details'),
      "show-title": !_vm.isSite,
      "layout": _vm.isSite ? 'right' : 'top',
      "is-edit": _vm.editing,
      "show-edit-button": _vm.isAdd ? false : true
    },
    on: {
      "edit": _vm.log,
      "cancel": _vm.log,
      "save": _vm.onSave
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": _vm.disabled ? 'left' : 'top',
      "label-width": _vm.disabled ? '' : '130px'
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10,
      "align": "start"
    }
  }, [(_vm.formData.type || _vm.editing) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 6
    }
  }, [(_vm.editing) ? _c('select-input', {
    attrs: {
      "label": "Type",
      "required": "",
      "list": _vm.workflowOption,
      "filterable": "",
      "create": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type", $$v)
      },
      expression: "formData.type"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isSite && (_vm.formData.category || _vm.editing)) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 6
    }
  }, [_c('select-input', {
    attrs: {
      "label": "Category",
      "list": _vm.wfCategoryOption,
      "filterable": "",
      "create": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.category),
      callback: function($$v) {
        _vm.$set(_vm.formData, "category", $$v)
      },
      expression: "formData.category"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.name || _vm.editing) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 18
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Name",
      "required": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isSite) ? [(_vm.formData.setupTime || _vm.editing) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Setup Time",
      "suffix": _vm.disabled ? _vm.formData.setupTimeUnits : '',
      "prefix": "fa fa-clock text-muted",
      "is-prefix-icon": true,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.setupTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "setupTime", $$v)
      },
      expression: "formData.setupTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 10,
      "lg": 6
    }
  }, [_c('select-input', {
    attrs: {
      "label": "Setup Units",
      "list": _vm.unitsOption,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.setupTimeUnits),
      callback: function($$v) {
        _vm.$set(_vm.formData, "setupTimeUnits", $$v)
      },
      expression: "formData.setupTimeUnits"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.taskTime || _vm.editing) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Task Time",
      "suffix": _vm.disabled ? _vm.formData.taskUnits : '',
      "prefix": "fa fa-clock text-muted",
      "is-prefix-icon": true,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.taskTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "taskTime", $$v)
      },
      expression: "formData.taskTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 10,
      "lg": 6
    }
  }, [_c('select-input', {
    attrs: {
      "label": "Task Units",
      "list": _vm.unitsOption,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.taskUnits),
      callback: function($$v) {
        _vm.$set(_vm.formData, "taskUnits", $$v)
      },
      expression: "formData.taskUnits"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.gradingMax || _vm.editing) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Max. Grading (1..X)",
      "suffix": "fa fa-star",
      "is-suffix-icon": true,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.gradingMax),
      callback: function($$v) {
        _vm.$set(_vm.formData, "gradingMax", $$v)
      },
      expression: "formData.gradingMax"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.isSite && _vm.formData.workforceReq) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 8
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Workforce (est.)",
      "prefix": "fa fa-users text-muted",
      "is-prefix-icon": true,
      "disabled": _vm.isSite ? true : !_vm.editing
    },
    model: {
      value: (_vm.formData.workforceReq),
      callback: function($$v) {
        _vm.$set(_vm.formData, "workforceReq", $$v)
      },
      expression: "formData.workforceReq"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSite && _vm.formData.workforceActual) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 8
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Workforce (actual)",
      "prefix": "fa fa-user text-muted",
      "is-prefix-icon": true,
      "suffix": '(est: ' + _vm.formData.workforceReq + ')',
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.workforceActual),
      callback: function($$v) {
        _vm.$set(_vm.formData, "workforceActual", $$v)
      },
      expression: "formData.workforceActual"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.notesToWorkers || _vm.editing) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('html-input', {
    attrs: {
      "label": "Notes to Workers",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.notesToWorkers),
      callback: function($$v) {
        _vm.$set(_vm.formData, "notesToWorkers", $$v)
      },
      expression: "formData.notesToWorkers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.remarks || _vm.editing) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('html-input', {
    attrs: {
      "label": "Remarks",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.formData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remarks", $$v)
      },
      expression: "formData.remarks"
    }
  })], 1) : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3899bf00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/EditWorkflow.vue
// module id = 1505
// module chunks = 0